module.exports = __webpack_public_path__ + "img/下载发票.07fc01a6.svg";